const stats = {
  CLOSURE_STATS_DATA_FETCH: 'CLOSURE_STATS_DATA_FETCH',
  CLOSURE_STATS_DATA_SUCCESS: 'CLOSURE_STATS_DATA_SUCCESS',
  CLOSURE_STATS_DATA_ERROR: 'CLOSURE_STATS_DATA_ERROR',
};

const transactions = {
  CLOSURE_TRANSACTIONS_FETCH: 'CLOSURE_TRANSACTIONS_FETCH',
  CLOSURE_TRANSACTIONS_SUCCESS: 'CLOSURE_TRANSACTIONS_SUCCESS',
  CLOSURE_TRANSACTIONS_ERROR: 'CLOSURE_TRANSACTIONS_ERROR',
};

const items = {
  CLOSURE_ITEMS_FETCH: 'CLOSURE_ITEMS_FETCH',
  CLOSURE_ITEMS_SUCCESS: 'CLOSURE_ITEMS_SUCCESS',
  CLOSURE_ITEMS_ERROR: 'CLOSURE_ITEMS_ERROR',
};

const output = { ...stats, ...transactions, ...items };
export default output;
